module.exports = __webpack_public_path__ + "static/media/cz.2a9d93fe.svg";